import { $ } from "@/common/Axios";

export default {
  /**
   * 招生业绩核对
   */
  monthReviewTeacher_updatePerformanceTime: {
    /*
     * 单个更新业绩发放时间或业绩扣费时间
     * schoolRollIds 合同编号 (array query required)
     * type 类型：业绩发放时间|业绩扣费时间 (string query required)
     * performanceTime 业绩发放时间|业绩扣费时间 (string query )
     * performanceStatus 业绩发放状态|业绩扣费状态， 历史扣费和历史发放可以不填时间 (string query )
     */
    put: (p, c) =>
      $.put(
        "/api/bms/personnel/monthReviewTeacher/updatePerformanceTime",
        p,
        c
      ),
  },
  monthReviewTeacher_confirmStatus: {
    /*
     * 确认|上报异议业绩核对（招生老师）
     * reviewEnrollId 详情id (integer query required)
     * status 状态：已确认|上报异议 (string query required)
     * remark 上报异议备注 (string query )
     */
    put: (p, c) =>
      $.put("/api/bms/personnel/monthReviewTeacher/confirmStatus", p, c),
  },
  monthReviewTeacher_addDissent: {
    /*
     * 新增上报异议
     * id 列表id (integer query required)
     * schoolRollId 合同编号 (integer query required)
     * remark 上报异议备注 (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/personnel/monthReviewTeacher/addDissent", p, c),
  },
  monthReviewTeacher_listRefund: {
    /*
     * 内部管理-退费业绩核对-列表
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/monthReviewTeacher/listRefund", p, c),
  },
  monthReviewTeacher_listRefundForPersonnel: {
    /*
     * 人事平台-退费业绩核对-列表
     */
    get: (p, c) =>
      $.get(
        "/api/bms/personnel/monthReviewTeacher/listRefundForPersonnel",
        p,
        c
      ),
  },
  monthReviewTeacher_listExtraPay: {
    /*
     * 内部管理-补缴业绩核对-列表
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/monthReviewTeacher/listExtraPay", p, c),
  },
  monthReviewTeacher_listExtraPayForPersonnel: {
    /*
     * 人事平台-补缴业绩核对-列表
     */
    get: (p, c) =>
      $.get(
        "/api/bms/personnel/monthReviewTeacher/listExtraPayForPersonnel",
        p,
        c
      ),
  },
  monthReviewTeacher_listEnroll: {
    /*
     * 内部管理-招生业绩核对-列表
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/monthReviewTeacher/listEnroll", p, c),
  },
  monthReviewTeacher_listEnrollForPersonnel: {
    /*
     * 人事平台-招生业绩核对-列表
     */
    get: (p, c) =>
      $.get(
        "/api/bms/personnel/monthReviewTeacher/listEnrollForPersonnel",
        p,
        c
      ),
  },
  monthReviewTeacher_exportRefundForPersonnel: {
    /*
     * 人事平台-退费业绩核对-导出
     */
    get: (p, c) =>
      $.get(
        "/api/bms/personnel/monthReviewTeacher/exportRefundForPersonnel",
        p,
        c
      ),
  },
  monthReviewTeacher_exportExtraPayForPersonnel: {
    /*
     * 人事平台-退费业绩核对-导出
     */
    get: (p, c) =>
      $.get(
        "/api/bms/personnel/monthReviewTeacher/exportExtraPayForPersonnel",
        p,
        c
      ),
  },
  monthReviewTeacher_exportEnrollForPersonnel: {
    /*
     * 人事平台-招生业绩核对-导出
     */
    get: (p, c) =>
      $.get(
        "/api/bms/personnel/monthReviewTeacher/exportEnrollForPersonnel",
        p,
        c
      ),
  },
  monthReviewTeacher_details: {
    /*
     * 详情
     * id 列表id (integer query required)
     * confirmStatus 确认状态：未确认|已确认|上报异议 (string query )
     * name 学生姓名 (string query )
     * oldType 是否老带新 (string query )
     * referralType 是否老生续读 (string query )
     * performanceStatus 业绩发放状态 (string query )
     * performanceRefundStatus 业绩扣费状态 (string query )
     */
    get: (p, c) => $.get("/api/bms/personnel/monthReviewTeacher/details", p, c),
  },

  /**
   * 业绩月份
   */
  monthReview_publishForCheck: {
    /*
     * 下发核对
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/personnel/monthReview/publishForCheck", p, c),
  },
  monthReview_finish: {
    /*
     * 标记完成（阶段为下发核对中时显示）
     * id id (integer query required)
     * sixtyPayed 首次补缴奖励是否已发放 (string query )
     * performanceTime 业绩发放或退费时间 (string query )
     */
    put: (p, c) => $.put("/api/bms/personnel/monthReview/finish", p, c),
  },
  monthReview_dingNotice: {
    /*
     * 一键提醒
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/personnel/monthReview/dingNotice", p, c),
  },
  monthReview_save: {
    /*
     * 添加|编辑
     * id id，编辑传入 (integer query )
     * year 年度 (integer query required)
     * month 月份 (integer query required)
     * contractFinishStartTime 合同成交开始时间 (string query )
     * contractFinishEndTime 合同成交结束时间 (string query )
     * contractCancelStartTime 退费开始时间 (string query )
     * contractCancelEndTime 退费截止时间 (string query )
     * firstFeeConfirmStartTime 首次学费补缴开始时间 (string query )
     * firstFeeConfirmEndTime 首次学费补缴截止时间 (string query )
     */
    post: (p, c) => $.post("/api/bms/personnel/monthReview/save", p, c),
  },
  monthReview_reFreshWithoutCheck: {
    /*
     * 刷新数据(不限制阶段,完成之前皆可)
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/bms/personnel/monthReview/reFreshWithoutCheck", p, c),
  },
  monthReview_initData: {
    /*
     * 刷新数据(未开始阶段)
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/personnel/monthReview/initData", p, c),
  },
  monthReview_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/personnel/monthReview/list", p, c),
  },
  monthReview_export: {
    /*
     * 导出
     * id 列表id (integer query required)
     * type 类型 (string query )
     */
    get: (p, c) => $.get("/api/bms/personnel/monthReview/export", p, c),
  },
  monthReview_exportForTeacher: {
    /*
     * 导出业绩详情-内部管理
     * id 列表id (integer query required)
     * type 类型 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/personnel/monthReview/exportForTeacher", p, c),
  },
  monthReview_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/personnel/monthReview/remove", p, c),
  },
  monthReview_removeReviewTeacher: {
    /*
     * 删除单条业绩老师
     * id 详情返回的列表id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/personnel/monthReview/removeReviewTeacher", p, c),
  },
  monthReview_removeReviewEnroll: {
    /*
     * 删除单条合同数据
     * id 合同列表返回的id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/personnel/monthReview/removeReviewEnroll", p, c),
  },

  /**
   * 上报异议
   */
  enrollDissent_updateOperatorId: {
    /*
     * 变更处理人
     * id 列表id (integer query required)
     * newOperatorId 新处理人 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/personnel/enrollDissent/updateOperatorId", p, c),
  },
  enrollDissent_addDispose: {
    /*
     * 添加处理内容
     * id 列表id (integer query required)
     * content 处理内容 (string query required)
     * result 处理结果（通过、拒绝） (string query required)
     */
    put: (p, c) => $.put("/api/bms/personnel/enrollDissent/addDispose", p, c),
  },
  enrollDissent_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/personnel/enrollDissent/list", p, c),
  },
  enrollDissent_listRecord: {
    /*
     * 上报异议处理记录
     * monthReviewEnrollId monthReviewEnrollId (integer query required)
     */
    get: (p, c) => $.get("/api/bms/personnel/enrollDissent/listRecord", p, c),
  },
};
